import removeEmojis from "../utils/removeEmojis";

/*****새로운 수업도구 추가시 처리 방법*****
    1. toolkitInfo에 신규 수업도구 항목 추가
*/

const makeToolkitInfo = () => {
    // let toolkitInfo = {
    //     toolkits: getData('toolkits'),
    //     toolbarAutoHide: getData('toolbarAutoHide'),
    //     toolLayerAutoHide: getData('toolLayerAutoHide'),
    //     toolbarPosition: getData('toolbarPosition'),
    //     toolbarStyle: getData('toolbarStyle'), //수업도구바 스타일선택 기능추가로 추가
    //     boardAutoSave: getData('boardAutoSave'), //판서 저장기능추가로 추가
    //     usernameHide: getData('usernameHide'), //닉네임 숨김기능추가로 추가
    //     tonlyAll: getData('tonlyAll'), //선생님 맞춤 기능추가로 추가
    //     randomPresetOrder: getData('randomPresetOrder'), //선생님 맞춤 기능 - 뽑기 순서 미리 지정 기능 추가로 추가
    //     originImage: getData('originImage'),
    //     originImageSeq: getData('originImageSeq'),
    //     thumbImage: getData('thumbImage'),
    //     thumbImageSeq: getData('thumbImageSeq'),
    //     selectBg: getData('selectBg'),
    //     staticBgInit: getData('staticBgInit'), //고정배경지정으로 추가
    //     staticBg: getData('staticBg'), //고정배경지정으로 추가
    //     stopwatch: getData('stopwatch'),
    //     timer: getData('timer'),
    //     dice: getData('dice'),
    //     coin: getData('coin'),
    //     random: getData('random'),
    //     wheel: getData('wheel'),
    //     memo: getData('memo'),
    //     memos: getData('memos'), //메모리스트 추가로 새로운 데이타 생성
    //     whistler: getData('whistler'),
    //     noisemonitor: getData('noisemonitor'),
    //     qrcode: getData('qrcode'),
    //     qrcodes: getData('qrcodes'), //qrcode 리스트 추가로 새로운 데이타 생성
    //     qrcodeBookmark: getData('qrcodeBookmark'), //qrcode북마크 추가로 추가
    //     clock: getData('clock'),
    //     crayon: getData('crayon'),
    //     board: getData('board'),
    //     boards: getData('boards'), //판서리스트 추가로 새루운 데이타 생성
    //     classthermo: getData('classthermo'),
    //     crayon_data: getData('crayon_data'),
    //     board_data: getData('board_data'),
    //     wheel_data: getData('wheel_data'),
    //     random_data: getData('random_data'),
    //     noisemonitor_data: getData('noisemonitor_data'), //민감도 데이타 추가
    //     timer_data: getData('timer_data'), //제목, 효과음설정 데이타 저장 추가
    //     bgm: getData('bgm'),
    //     effect: getData('effect'),
    //     customBgm: getData('customBgm'),
    //     customEffect: getData('customEffect'),
    //     bookmarkBgm: getData('bookmarkBgm'),
    //     bookmarkEffect: getData('bookmarkEffect'),
    //     suggestionList: getData('suggestionList'), //제안및문의 답변 알림히스토리 저장 데이타 추가
    //     scoreboard: getData('scoreboard'), //점수판 추가
    //     scoreboard_data: getData('scoreboard_data'), //점수판 저장 데이타 추가
    //     video: getData('video'), //영상재생 추가
    //     videos: getData('videos'), //영상재생 저장 데이타 추가
    //     clock_data: getData('clock_data'), //시계 기능추가로 데이타 추가
    //     toolOrder: getData('toolOrder'), //수업도구바 순서 조절기능추가로 데이타 추가
    //     nationalrite: getData('nationalrite'), //국민의례 추가
    //     nationalrite_data: getData('nationalrite_data'), //국민의례 데이타 추가
    //     seatswapper: getData('seatswapper'), //자리바꾸기 추가로 데이타 추가
    //     seatswapper_data: getData('seatswapper_data'), //자리바꾸기 추가로 데이타 추가
    //     scoreAutoSave: getData('scoreAutoSave'), //판서 저장기능추가로 추가
    //     air: getData('air'), //미세먼지측정기 추가로 추가
    //     air_data: getData('air_data'), //미세먼지측정기 추가로 추가
    //     digitaledutool: getData('digitaledutool'), //디지털교구모음 추가로 추가
    //     digitaledutool_data: getData('digitaledutool_data'), //디지털교구모음 추가로 추가
    //     checklist: getData('checklist'), //체크리스트 추가로 추가
    //     checklist_data: getData('checklist_data'), //체크리스트 추가로 추가
    //     marble: getData('marble'), //체크리스트 추가로 추가
    //     marble_data: getData('marble_data'), //체크리스트 추가로 추가
    // };

    //사이트 설정 데이타만 저장
    let toolkitInfo = {
        toolkits: getData('toolkits'),
        toolbarAutoHide: getData('toolbarAutoHide'),
        toolLayerAutoHide: getData('toolLayerAutoHide'),
        toolbarPosition: getData('toolbarPosition'),
        toolOpenMode: getData('toolOpenMode'),
        toolbarStyle: getData('toolbarStyle'), //수업도구바 스타일선택 기능추가로 추가
        usernameHide: getData('usernameHide'), //닉네임 숨김기능추가로 추가
        tonlyAll: getData('tonlyAll'), //선생님 맞춤 기능추가로 추가
        randomPresetOrder: getData('randomPresetOrder'), //선생님 맞춤 기능 - 뽑기 순서 미리 지정 기능 추가로 추가
        seatswapperPresetOrder: getData('seatswapperPresetOrder'), //선생님 맞춤 기능
        originImage: getData('originImage'),
        originImageSeq: getData('originImageSeq'),
        thumbImage: getData('thumbImage'),
        thumbImageSeq: getData('thumbImageSeq'),
        selectBg: getData('selectBg'),
        staticBgInit: getData('staticBgInit'), //고정배경지정으로 추가
        staticBg: getData('staticBg'), //고정배경지정으로 추가
        stopwatch: getData('stopwatch'),
        timer: getData('timer'),
        dice: getData('dice'),
        coin: getData('coin'),
        random: getData('random'),
        wheel: getData('wheel'),
        memo: getData('memo'),
        whistler: getData('whistler'),
        noisemonitor: getData('noisemonitor'),
        qrcode: getData('qrcode'),
        clock: getData('clock'),
        crayon: getData('crayon'),
        board: getData('board'),
        classthermo: getData('classthermo'),
        suggestionList: getData('suggestionList'), //제안및문의 답변 알림히스토리 저장 데이타 추가
        scoreboard: getData('scoreboard'), //점수판 추가
        video: getData('video'), //영상재생 추가
        toolOrder: getData('toolOrder'), //수업도구바 순서 조절기능추가로 데이타 추가
        movedTools: getData('movedTools'), //위치이동한 툴 저장체크로 추가
        nationalrite: getData('nationalrite'), //국민의례 추가
        seatswapper: getData('seatswapper'), //자리바꾸기 추가로 데이타 추가
        air: getData('air'), //미세먼지측정기 추가로 추가
        digitaledutool: getData('digitaledutool'), //디지털교구모음 추가로 추가
        checklist: getData('checklist'), //체크리스트 추가로 추가
        marble: getData('marble'), //체크리스트 추가로 추가
        tournament: getData('tournament'), //대진표 추가로 추가
        dday: getData('dday'), //dday 추가로 추가
        note: getData('note'),
        classduty: getData('classduty'),
        dataMigrated: true, //툴킷 정보 분리 저장했다는 정보 추가(중요)
    };

    function getData(key) {
        let value = JSON.parse(localStorage.getItem(key));
        // console.log(key, value);
        return value;
    }

    function setData(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    function getByteSizeOfObject(obj) {
        var jsonString = JSON.stringify(obj);
        alert(getByteSize(jsonString));
        // console.log(getByteSize(jsonString))
    }

    function getByteSize(str) {
        // UTF-8 인코딩을 사용하는 경우
        return new Blob([str]).size;
    }

    function toKoreanISOString(timestamp) {
        const date = new Date(timestamp);
        // 9시간(UTC+9)을 더하여 KST로 변환
        const kstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);
    
        // ISO 8601 형식으로 변환
        return kstDate.toISOString().replace("Z", "+09:00");
    }

    // getByteSizeOfObject(toolkitInfo)
    
    // console.log('toolkitInfo', JSON.stringify(toolkitInfo));

    // return  JSON.stringify(toolkitInfo).replaceAll("%", "％");

    // toolkitInfo를 문자열로 변환한 후 이모지를 제거
    const toolkitInfoString = JSON.stringify(toolkitInfo);
    const cleanedString = removeEmojis(toolkitInfoString);
    // const cleanedString = toolkitInfoString; //테스트용(241125)
    // 이모지를 삭제한 cleanedString 객체를 로컬스토리지에 저장(241125)
    const timestamp = Date.now(); // 현재 타임스탬프
    // console.log('sized', getByteSize(cleanedString))
    setData('originalToolkitInfo', {
        value: cleanedString,
        update: toKoreanISOString(timestamp)
    });

    // return cleanedString.replaceAll("%", "％").replaceAll("+", "＋");
    return cleanedString.replaceAll("%", "％");
};

export default makeToolkitInfo;
